import React, { Component } from 'react';
import { connect } from 'react-redux';
import { initialize } from 'redux-form';
import { loadVouchers } from './actions';
import Filter from './Filter';
import List from './List';
import authUtils from '../../auth/utils';

class Vouchers extends Component {
	constructor(props) {
		super(props);
		this.handleFilterSubmit = this.handleFilterSubmit.bind(this);
		this.handleFilterReset = this.handleFilterReset.bind(this);
		this.handleListEvent = this.handleListEvent.bind(this);
	}

	componentDidMount() {
		const { filter, sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;
		
		this.loadData({ filter, sortKey, sortDirection, pageNumber, pageSize });
		this.props.initializeFilter(filter);
	}

	loadData({ filter, sortKey, sortDirection, pageNumber, pageSize }) {
		this.props.loadEntities({...filter, sortKey, sortDirection, pageSize, pageNumber});
	}
	
	handleFilterSubmit(filter) {
		const { sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;
		this.loadData({ filter, sortKey, sortDirection, pageNumber: 1, pageSize });
	}

	handleFilterReset() {
		this.handleFilterSubmit({});
	}

	handleListEvent(listPagination) {
		const { filter } = this.props.pagination;
		this.loadData({ filter, ...listPagination });
	}

	render() {
		const { isReadonly } = this.props;
		return (
			<div>
				<Filter onSubmit={this.handleFilterSubmit} onReset={this.handleFilterReset} loading={this.props.pagination.loading} />
				<List isReadonly={isReadonly} onFetchData={this.handleListEvent} data={this.props.data} {...this.props.pagination} />
			</div>
		);
	}
}

const mapStateToProps = state => {
	const {
		pagination,
		entities: { vouchers },
		auth: { currentUser }
	} = state;

	const vouchersPagination = pagination.vouchers.all || { ids: [], pageNumber: 1, pageSize: 10 };

	return {
		data: vouchersPagination.ids.map(id =>vouchers[id]),
		pagination:vouchersPagination,
		isReadonly: authUtils.hasReadOnlyPermission(currentUser, 'Vouchers')
	};
};

export default connect(mapStateToProps, {
	loadEntities: loadVouchers,
	initializeFilter: (data, fields) => initialize('vouchersFilter', data, fields)
})(Vouchers);